import{_ as o}from"./tslib.es6-CmLYFWVC.js";import{property as t}from"lit/decorators.js";function r(r){class s extends r{constructor(){super(...arguments),this.autocomplete="off"}}return o([t()],s.prototype,"autocomplete",void 0),s}export{r as A};
//# sourceMappingURL=AutocompleteMixin-D8eiOxvO.js.map
